import { render, staticRenderFns } from "./SimpleReviewQuotesCarousel.vue?vue&type=template&id=4a5c3308&lang=pug"
import script from "./SimpleReviewQuotesCarousel.vue?vue&type=script&lang=js"
export * from "./SimpleReviewQuotesCarousel.vue?vue&type=script&lang=js"
import style0 from "./SimpleReviewQuotesCarousel.vue?vue&type=style&index=0&id=4a5c3308&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports